{
  "countdown_days": {
    "one": "En {count} día",
    "other": "En {count} días"
  },
  "countdown_months": {
    "one": "En más o menos un mes",
    "other": "En más o menos {count} meses"
  },
  "countdown_today": "Hoy 🥂",
  "countdown_tomorrow": "¡Mañana!",
  "countdown_weeks": {
    "one": "En una semana",
    "other": "En {count} semanas"
  },
  "countdown_years": {
    "one": "En más o menos un año",
    "other": "En más o menos {count} años"
  },
  "create_new_list": "Crear lista nueva",
  "feed_added": {
    "one": "{name} puso {count} cosa en {list}",
    "other": "{name} puso {count} cosas en {list}"
  },
  "feed_added_one": "{name} puso {thing} en {list}",
  "feed_follower": "{name} te sigue",
  "feed_gifting": "{name} le va a regalar {thing} a {owner}",
  "feed_gifting_guest": "{name} le va a regalar {thing} a {owner} (por enlace)",
  "feed_gifting_you": "Alguien te va a regalar {thing}",
  "feed_got": "{name} ya tiene {thing}",
  "feed_heading": "Novedades",
  "feed_new": "Nuevo",
  "feed_shared": {
    "one": "{name} compartió {list} contigo · {count} cosa",
    "other": "{name} compartió {list} contigo · {count} cosas"
  },
  "gifting_for": "Para {name}",
  "gifting_heading": "Lo que regalo",
  "gifting_see_all": "Ver todo ({count})",
  "greeting": "¡Hola, {name}!",
  "join_failed": "No se pudo hacer. ¿Lo intentas de nuevo?",
  "join_from": "desde {list}",
  "join_heading": "{name} quiere unirse",
  "join_invite": "Invitar a {name}",
  "join_invited": "Invitaste a {name}",
  "join_inviting": "Invitando…",
  "join_kicker": "Quiere unirse",
  "join_none_left": "Por ahora no te quedan invitaciones. Se agregan más automáticamente, y esto espera aquí hasta entonces.",
  "join_not_now": "Ahora no",
  "join_offline": "No tienes conexión. Inténtalo de nuevo cuando estés en línea.",
  "join_signed_out": "Vuelve a iniciar sesión para responder.",
  "join_what": "Invitarle usa una de tus invitaciones. Te seguirá y estará en {list}, y lo que vaya a regalar de ella pasa a ser suyo en la app.",
  "join_what_no_list": "Invitarle usa una de tus invitaciones, y te seguirá.",
  "page_description": "Brindemos por las cosas que quieres.",
  "page_title": "TingThings — Brindemos por las cosas que quieres",
  "recent_activity": "Actividad reciente",
  "see_all": "Ver todas",
  "stat_gifts_receiving": "Regalos que recibirás",
  "stat_things_on_lists": "Cosas en tus listas",
  "subhead": "Esto es lo que está pasando",
  "upnext_empty": "Aún no tiene nada",
  "upnext_wanted": {
    "one": "{count} cosa que aún quieres",
    "other": "{count} cosas que aún quieres"
  },
  "ways_got_it": "Entendido",
  "ways_heading": "Tres formas de guardar algo",
  "ways_heading_web": "Dos formas de guardar algo",
  "ways_intro": "Lo que quieras, guardarlo está a un toque de aquí.",
  "ways_paste": "Pega un enlace",
  "ways_paste_hint": "Copia un enlace en cualquier lugar y pégalo aquí",
  "ways_photo": "Toma una foto",
  "ways_photo_hint": "Tómala en la tienda. Las palabras son opcionales.",
  "ways_share": "Compártelo desde cualquier app",
  "ways_share_drawing": "Una hoja de compartir, con {app} en su fila de apps",
  "ways_share_hint": "Desde Safari, la app de una tienda, donde sea",
  "ways_share_more": "¿No aparece en la fila de apps? Desliza hasta el final, toca Más y activa {app}.",
  "ways_share_step1": "Toca Compartir en la app donde estés.",
  "ways_share_step2": "Toca {app}. Listo: queda guardado.",
  "your_lists": "Tus listas"
}
